import { TRANS_WEBP_STR } from '@commonPackage/components';

export const BANNER_DATA_LIST = [
  {
    img: `https://static.fuxi.netease.com/yaotai/portal/index/lgarnl2p_075184.png?${TRANS_WEBP_STR}`,
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbld5c3_976705.mp4',
    title: '私域元宇宙',
  },
  {
    img: `https://static.fuxi.netease.com/yaotai/portal/index/lgarnl2o_075183.png?${TRANS_WEBP_STR}`,
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgc8n9yq_080433.mp4',
    title: '数字文旅',
  },
  {
    img: `https://static.fuxi.netease.com/yaotai/portal/index/lgarnl2q_075184.png?${TRANS_WEBP_STR}`,
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbld5c4_976705.mp4',
    title: '营销活动',
  },
  {
    img: `https://static.fuxi.netease.com/yaotai/portal/index/lgarnl2r_075184.png?${TRANS_WEBP_STR}`,
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbld5c5_976705.mp4',
    title: '展览展厅',
  },
  {
    img: `https://static.fuxi.netease.com/yaotai/portal/index/lgarnl2n_075183.png?${TRANS_WEBP_STR}`,
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbld5c6_976705.mp4',
    title: '企业空间',
  },
];
export const RECOMMEND_BANNER_LIST = [
  {
    img: `httpshttps://static.fuxi.netease.com/yaotai/portal/index/lgarnl2p_075184.png?${TRANS_WEBP_STR}`,
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbld5c3_976705.mp4',
    title: '私域元宇宙',
  },
  {
    img: `https://static.fuxi.netease.com/yaotai/portal/index/lgarnl2o_075183.png?${TRANS_WEBP_STR}`,
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgc8n9yq_080433.mp4',
    title: '数字文旅',
  },
  {
    img: `https://static.fuxi.netease.com/yaotai/portal/index/lgarnl2q_075184.png?${TRANS_WEBP_STR}`,
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbld5c4_976705.mp4',
    title: '营销活动',
  },
  {
    img: `https://static.fuxi.netease.com/yaotai/portal/index/lgarnl2r_075184.png?${TRANS_WEBP_STR}`,
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbld5c5_976705.mp4',
    title: '展览展厅',
  },
  {
    img: `https://static.fuxi.netease.com/yaotai/portal/index/lgarnl2n_075183.png?${TRANS_WEBP_STR}`,
    video: 'https://static.fuxi.netease.com/yaotai/portal/index/lgbld5c6_976705.mp4',
    title: '企业空间',
  },
  {
    img: `https://static.fuxi.netease.com/danlu/index_module/index/ll4w6h7x_789741.png?${TRANS_WEBP_STR}`,
    video: 'https://static.fuxi.netease.com/danlu/index_module/index/ll4w587m_731409.mp4',
    title: '发布会',
  },
  {
    img: `https://static.fuxi.netease.com/danlu/index_module/index/ll5242p1_755301.png?${TRANS_WEBP_STR}`,
    video: 'https://static.fuxi.netease.com/danlu/index_module/index/ll52ftma_303410.mp4',
    title: '会议',
  },
];
export const FADE_ROW_DATA_LIST1 = [
  {
    title: '随时随地便捷访问',
    desc: '无需下载、安装，输入门票即可一键参与，轻松打破传统活动时空局限',
    logo: `https://static.fuxi.netease.com/yaotai/portal/index/lgbngitw_493396.png?${TRANS_WEBP_STR}`,
  },
  {
    title: '活动空间自由定制',
    desc: '满足活动主办方各类需求，支持个性化空间场景、角色和功能定制',
    logo: `https://static.fuxi.netease.com/yaotai/portal/index/lgbngitx_493396.png?${TRANS_WEBP_STR}`,
  },
];
export const FADE_ROW_DATA_LIST2 = [
  {
    title: '一站式活动管理',
    desc: '打通活动报名、场地部署、会议控场、数据分析等活动管理全流程',
    logo: `https://static.fuxi.netease.com/yaotai/portal/index/lgd9gy74_931039.png?${TRANS_WEBP_STR}`,
  },
  {
    title: '深厚技术底蕴支持',
    desc: '可容纳万人同屏、实时互动，告别卡顿、延迟现象，保证高精度的渲染',
    logo: `https://static.fuxi.netease.com/yaotai/portal/index/lgbngitz_493397.png?${TRANS_WEBP_STR}`,
  },
];
